import { useEffect, useState } from "react";
import marca from "../../../assets/marca-verificando-sessao.png";

/** Um ciclo da varredura (mesmo tempo do CSS). O splash fica pelo menos isto. */
export const DURACAO_MINIMA_DA_TELA_MS = 2_200;

/** `true` depois do minimo. Sem sessao conhecida, libera na hora: visita fria vai pro login. */
export function useMinimoDaTelaDeSessao(
  minimoMs = DURACAO_MINIMA_DA_TELA_MS,
  ativo = true,
): boolean {
  const [passou, setPassou] = useState(!ativo);
  useEffect(() => {
    if (!ativo) {
      setPassou(true);
      return;
    }
    setPassou(false);
    const id = window.setTimeout(() => setPassou(true), minimoMs);
    return () => window.clearTimeout(id);
  }, [minimoMs, ativo]);
  return passou;
}

/**
 * Splash enquanto a sessao e conferida. A marca e um desenho branco: no tema
 * claro ela inverte para preto; no escuro fica branca, sobre o fundo da pagina.
 */
export function TelaDeVerificacaoDeSessao() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-bloco bg-page-background p-6">
      <div className="relative w-60" aria-hidden="true">
        <img
          src={marca}
          alt=""
          className="block w-full invert dark:invert-0"
        />
        <span className="varredura-da-sessao pointer-events-none absolute top-0 -left-[8%] w-[116%] bg-foreground" />
      </div>
      <p role="status" aria-live="polite" className="text-sm text-muted-foreground">
        Verificando a sua sessão
      </p>
    </div>
  );
}
